import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Alert from '../../../Alert.js';
import Col from '../../../Grid/Col.js';
import Row from '../../../Grid/Row.js';
import CheckCircle from '../../../Icons/CheckCircle.js';
import Shield from '../../../Icons/Shield.js';
import XCircle from '../../../Icons/XCircle.js';
import Well from '../../../Well.js';
import { Box } from '../Helpers.js';
import CommonEvent from './CommonEvents.js';
const AutoCallEventCmp = (props) => {
    switch (props.event.type) {
        case InteractionEventType.Started:
        case InteractionEventType.Ringing:
        case InteractionEventType.Answered:
        case InteractionEventType.Inbound:
            return React.createElement(SimpleEvent, { event: props.event });
        case InteractionEventType.Completed:
            return React.createElement(CompletedEvent, { event: props.event });
        case InteractionEventType.Failed:
            return React.createElement(FailedEvent, { event: props.event });
        case InteractionEventType.Cancelled:
            return React.createElement(CancelledEvent, { event: props.event });
        case InteractionEventType.HumanAnswered:
            return React.createElement(HumanAnsweredEvent, { event: props.event });
        case InteractionEventType.Voicemail:
            return React.createElement(VoicemailEvent, { event: props.event });
        case InteractionEventType.DigitsEntered:
            return React.createElement(DigitsEnteredEvent, { event: props.event });
        default:
            return React.createElement(CommonEvent, { event: props.event });
    }
};
const SimpleEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } }, lang.interactionEventTypes[event.type]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }))));
};
const CompletedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(CheckCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Completed]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.deliveredAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.duration, body: `${event.data.duration}s` })),
        event.data.network && (React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.network, body: event.data.network })))));
};
const FailedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Failed]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.failedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            event.data.errorCode && (React.createElement(Box, { header: lang.interactions.errorCode, body: event.data.errorCode }))),
        event.data.reason && (React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: {
                        fontSize: '0.9em',
                        opacity: 0.65,
                    } }, lang.interactions.reason),
                React.createElement("p", { style: { fontFamily: 'JetBrains Mono, monospace' } },
                    React.createElement("code", null, event.data.reason)))))));
};
const CancelledEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Cancelled]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            event.data.errorCode && (React.createElement(Box, { header: lang.interactions.errorCode, body: event.data.errorCode }))),
        event.data.reason && (React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: {
                        fontSize: '0.9em',
                        opacity: 0.65,
                    } }, lang.interactions.reason),
                React.createElement("p", { style: { fontFamily: 'JetBrains Mono, monospace' } },
                    React.createElement("code", null, event.data.reason)))))));
};
const HumanAnsweredEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(CheckCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.HumanAnswered]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            event.data.subState && (React.createElement(Box, { header: lang.interactions.subState, body: event.data.subState })))));
};
const VoicemailEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } }, lang.interactionEventTypes[InteractionEventType.Voicemail]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            event.data.subState && (React.createElement(Box, { header: lang.interactions.subState, body: event.data.subState })))));
};
const DigitsEnteredEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } }, lang.interactionEventTypes[InteractionEventType.DigitsEntered]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.digits, body: React.createElement("span", { style: { fontFamily: 'JetBrains Mono, monospace' } }, event.data.digits || 'N/A') })),
        event.data.timedOut && (React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.timedOut, body: lang.interactions.timedOutDescription })))));
};
export default AutoCallEventCmp;
//# sourceMappingURL=AutoCall.js.map